import { render } from "./WhatsAppSettingsView.vue?vue&type=template&id=9c8b86ec&scoped=true"
import script from "./WhatsAppSettingsView.vue?vue&type=script&lang=js"
export * from "./WhatsAppSettingsView.vue?vue&type=script&lang=js"

import "./WhatsAppSettingsView.vue?vue&type=style&index=0&id=9c8b86ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c8b86ec"]])

export default __exports__